import get from 'lodash/get';

function calculateFilterExpression(
	value: string,
	selectedFilterOperations: string,
	target: string
) {
	const context = {
		column: this
	};

	if (target === 'filterRow' || target === 'search') {
		const fieldName = this.dataField;
		const getter = function (data: any) {
			const field = get(data, fieldName);
			return field?.normalize?.('NFD').replace(/[\u0300-\u036f]/g, '') || field;
		};

		getter.context = context;

		value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

		return [getter, selectedFilterOperations || 'contains', value];
	}

	return this.defaultCalculateFilterExpression.apply(this, arguments);
}

// Bu işlem string dataType olan kolonlarda türkçe karakter ile arama yapılmasına olanak sağlamaktadır. Sadece remoteOperations property değeri false ise kullanılmalıdır.
export const customizeColumns = columns => {
	columns.forEach((column, index) => {
		if (column.dataType === 'string') {
			columns[index].calculateFilterExpression = calculateFilterExpression;
		}
	});
};
